module.exports = __webpack_public_path__ + "static/media/dubai-computer-science.c02625a6.png";